const header = {
  upgrade: '升级套餐',
  profile: '个人中心',
  changeLanguage: '切换语言',
  simplifiedChinese: '简体中文',
  english: 'English',
  logout: '退出登录',
  tagName: '标签名称',
  createSuccess: '创建成功',
  cancel: '取消',
  confirm: '确认',
  extensionStatus: '状态',
  extensionChecking: '检测中',
  extensionConnected: '已连接',
  extensionMissing: '未安装插件',
  extensionRetry: '点击重新检测',
  adminMode: '管理模式',
  on: '开启',
  off: '关闭',
  notifications: '通知',
  unreadNotifications: '通知，有未读消息',
  expandSidebar: '展开侧边栏',
  collapseSidebar: '收起侧边栏',
  notificationCurrent: '当前',
  announcementTitle: '双十一限定优惠已开启',
  announcementDesc:
    '双十一限时活动进行中，前往套餐页查看专属优惠。活动截至 2026 年 11 月 11 日 23:59（北京时间）。',
  pin: '置顶',
  unpin: '取消置顶',
  rename: '重命名',
  delete: '删除',
  deleteConfirm: '确认删除标签「{name}」吗？',
  deleteSuccess: '删除成功',
  updateSuccess: '更新成功',
  renameTitle: '重命名标签',
  newName: '新名称',
}

export default header
